// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__BVoU6","edit":"Profile_edit__5DiWF","icon":"Profile_icon__oSPAg","content":"Profile_content__QbCOE","rotate":"Profile_rotate__OvRty"};